import React from 'react';

const DataTableElement = ({ columns, items, tableLoad, classHead }) => {
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
      <table className="min-w-full w-full border-collapse">
        {/* HEADER */}
        <thead className={`bg-gray-50 border-b ${classHead}`}>
          <tr>
            {columns.map((col) => (
              <th
                key={col.id}
                className="px-5 py-4 text-left text-xs font-semibold uppercase tracking-wide text-gray-600"
              >
                {col.name}
              </th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody className="divide-y divide-gray-100">
          {/* LOADING */}
          {tableLoad.show && (
            <tr>
              <td colSpan={columns.length} className="py-10">
                <div className="flex flex-col items-center justify-center gap-3 text-gray-500">
                  <svg
                    className="animate-spin h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    />
                  </svg>

                  <span className="text-sm">
                    {tableLoad.textLoad ?? 'Loading data...'}
                  </span>
                </div>
              </td>
            </tr>
          )}

          {/* DATA */}
          {!tableLoad.show && items.length > 0 &&
            items.map((item) => (
              <tr
                key={item.id}
                className="hover:bg-gray-50 transition-colors"
              >
                {columns.map((col) => (
                  <td
                    key={col.id}
                    className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap"
                  >
                    {col.cell ? col.cell(item) : col.selector(item)}
                  </td>
                ))}
              </tr>
            ))}

          {/* EMPTY STATE */}
          {!tableLoad.show && items.length === 0 && (
            <tr>
              <td colSpan={columns.length} className="py-14">
                <div className="flex flex-col items-center justify-center gap-2 text-gray-400">
                  <i className="fas fa-inbox text-3xl"></i>
                  <p className="text-sm font-medium">
                    No records found
                  </p>
                  <p className="text-xs">
                    Try adjusting your filters or add a new item
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTableElement;
